import { useAsyncData } from '#imports'
import { computed, ref } from 'vue'

import { filterSelectedOfferABTestedPaymentMethods } from '@backmarket/nuxt-layer-payment/methods/helpers/filterABTestedPaymentMethods'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchPickers() {
  const pickersResponseCacheTagHeader = ref('')
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()
  const experiments = useExperiments()

  const response = useAsyncData(
    `pp-pickers-${productId}`,
    async () =>
      await $httpFetch('/product-page/products/:productId/pickers', {
        pathParams: { productId },
        onResponse(context) {
          pickersResponseCacheTagHeader.value =
            context.response?.headers.get('Cache-Tag') ?? ''
        },
      }),
    {
      dedupe: 'defer',
    },
  )

  const isOutOfStock = computed(() => {
    if (!response.data.value && !response.pending.value) {
      return true
    }

    return response.data?.value?.isOutOfStock ?? false
  })

  const selectedOffer = computed(() => {
    if (!response.data?.value?.selectedOffer || isOutOfStock.value) {
      return null
    }

    return filterSelectedOfferABTestedPaymentMethods(
      experiments,
      response.data.value?.selectedOffer,
    )
  })

  return {
    ...response,
    pickersResponseCacheTagHeader,
    isOutOfStock,
    selectedOffer,
  }
}
